export const API_ERROR_STRING = {
	ERR_401:
		'You do not have access to the requested information. For more info please contact Cargo Chief support.',
	ERR_400_500: 'We ran into a problem processing your request. Please try again in a few minutes.',
	ERR_500: 'Unprocessable request.',
	ERR_502: 'The C4 system is being updated. Please try again in a few minutes.',
	NOT_FOUND: 'NOT_FOUND',
};

export const LOGIN_ERROR = {
	ERR_APP: 'You are attempting to access the C4 application. LaneMaster partners should login at',
	ERR_CREDENTIALS:
		'The credentials provided did not match our system. Please check them and try again.',
};

export const LOGIN_ERROR_TYPE = {
	ERR_CREDENTIALS: 'wrong_credentials',
	ERR_APP: 'wrong_app',
};

export const PRICING_ERROR = {
	RECENT_TRANSACTION: {
		DEFAULT: 'Unable to load Recent Transactions',
	},
	LANE_PRICING: {
		DEFAULT: 'Unable to load Current Rates',
		ERR_404: 'Price predictions are not currently available for this lane',
	},
};

export const ADD_USER_ERROR = {
	DUPLICATE_ERROR: 'All emails provided are occuped',
	DUPLICATE_MSG: 'User with same email exist.',
};

export const CONTACT_CC: string = 'If the issue persists please contact Cargo Chief Support.';

export const MY_CARRIER_PACKETS_ERROR: string =
	'Unable to connect to MyCarrierPortal. Please check the username and password.';

export const UNABLE_TO_PROCESS_REQUEST: string = 'Unable to process your request';

export const SUBSCRIPTION_ERRORS = {
	SUBSCRIPTION_ALREADY_CANCELED: 'SUBSCRIPTION_ALREADY_CANCELED',
	NO_SUCH_SUBSCRIPTION: 'No such subscription',
	MISSING_SUBSCRIPTION_ID: 'MISSING_SUBSCRIPTION_ID',
	SUBSCRIPTION_NOT_FOUND: 'SUBSCRIPTION_NOT_FOUND',
};

export const MCP_UNAUTHORIZED: string = 'Authorization has been denied for this request.';
